__turbopack_context__.v({
  "className": "Q9oxRW_className",
  "variable": "Q9oxRW_variable",
});
